/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveOfferApiResponse } from '../models/ActiveOfferApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppOffersService {
    /**
     * Get the live offer for the signed-in client's country
     * Matches the client's phone dial code exactly against each offer's countries, but only when the account also has a phone number. Without one the country is unknown and the live guest offer is returned. Null when nothing applies. Not cached.
     * @returns ActiveOfferApiResponse Active offer fetched; data is null when none applies
     * @throws ApiError
     */
    public static clientOffersControllerGetActiveOfferV1(): CancelablePromise<ActiveOfferApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/offers/active',
            errors: {
                403: `Client access required`,
            },
        });
    }
}
